import { CopyTextButton } from "@components/copy-text-button";
import { Box } from "@mui-wrapper";
import { QRCodeSVG } from "qrcode.react";
import { LinkWithQRCodeDialogEvents } from "@utils/track-event/track-event-list";
import { QRCodeDialogLocation } from "@utils/track-event/event-types";
import { Dialog, TextField, Divider } from "@flat-ui";

interface Props {
  /** Title of the dialog */
  title: string;

  /** The link to be shown, copied and QR code is generated for */
  link: string;

  /** Callback when the dialog is closed */
  onDialogClose: () => void;

  /** The location in which this dialog is being opened */
  location: QRCodeDialogLocation;
}

/** Shows a link, with a copy button and QR code */
export function LinkWithQRCodeDialog({
  title,
  link,
  onDialogClose,
  location,
}: Props): React.JSX.Element {
  return (
    <Dialog
      open={true}
      title={title}
      onCancel={onDialogClose}
      cancelText="Close"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <QRCodeSVG value={link} size={256} />
      </Box>

      <Divider sx={{ my: 2 }}>Or enter the link manually</Divider>

      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        <TextField text={link} readOnly={true} sx={{ flex: 1 }} fullWidth />
        <CopyTextButton
          textToCopy={link}
          successMessage="Link copied to clipboard"
          failedMessage="Error: Failed to copy link to clipboard, please copy it manually"
          trackEventName={{
            name: LinkWithQRCodeDialogEvents.copyLink,
            props: {
              location,
            },
          }}
        />
      </Box>
    </Dialog>
  );
}
